import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Users, ClipboardCheck, GraduationCap, FileText, AlertTriangle, Heart, Crown } from 'lucide-react';
export function ProfessionalComparison() {
  const comparisons = [{
    situation: 'El AT implementa diferente a vos',
    without: 'No sabés hasta que el progreso se frena',
    with: 'Auditoría mensual detecta el desvío en semana 1'
  }, {
    situation: 'La familia no cumple los acuerdos',
    without: 'Frustración, conflicto, resultados nulos',
    with: 'Contrato de colaboración familiar con compromisos escritos'
  }, {
    situation: 'La escuela manda quejas sin datos',
    without: 'Reuniones que no producen nada',
    with: 'Cuaderno de enlace estructurado: datos claros cada semana'
  }, {
    situation: 'El informe trimestral de la Obra Social',
    without: '4-5 horas de trabajo desde cero',
    with: 'Formato completo de 5 secciones listo para completar'
  }, {
    situation: 'Un AT renuncia de un día para otro',
    without: 'Caos, el paciente queda sin atención',
    with: 'Protocolo de triage y ficha de traspaso lista'
  }, {
    situation: 'Trabajás con psicólogo y fonoaudiólogo y no están alineados',
    without: 'Cada uno tira para su lado',
    with: 'Scripts específicos para 4 conflictos interdisciplinarios'
  }];
  const modules = [{
    icon: <Crown className="w-6 h-6" data-id="element-250" />,
    title: 'Liderazgo Clínico',
    color: 'text-amber-300',
    bgColor: 'bg-amber-500/20',
    items: 'El modelo de las 168 horas · Mapa del caso coordinado · Los 3 acuerdos fundamentales · La diferencia entre técnico y Director Clínico'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-251" />,
    title: 'Gestión del AT',
    color: 'text-cyan-300',
    bgColor: 'bg-cyan-500/20',
    items: 'Manual relámpago completo · Algoritmo de la consecuencia · Ficha de paciente para el AT · Test de veracidad de datos · Formulario de feedback 3:1'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-252" />,
    title: 'Integración Familiar',
    color: 'text-rose-300',
    bgColor: 'bg-rose-500/20',
    items: 'Matriz de prioridad en el hogar · Protocolo de tarea mensual · Contrato de colaboración familiar · Scripts para las 5 conversaciones difíciles'
  }, {
    icon: <GraduationCap className="w-6 h-6" data-id="element-253" />,
    title: 'Coordinación Escolar Pro',
    color: 'text-blue-300',
    bgColor: 'bg-blue-500/20',
    items: 'Cuaderno de enlace estructurado · Reunión trimestral con estructura · Scripts para escuelas que resisten'
  }, {
    icon: <FileText className="w-6 h-6" data-id="element-254" />,
    title: 'Documentación Avanzada',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-500/20',
    items: 'Informe trimestral consolidado · Informe anual de logros · Todos los formatos de cierre y alta'
  }, {
    icon: <AlertTriangle className="w-6 h-6" data-id="element-255" />,
    title: 'Gestión de Conflictos y Crisis',
    color: 'text-orange-300',
    bgColor: 'bg-orange-500/20',
    items: '4 conflictos con script completo · Protocolo de triage clínico · Gestión de crisis del equipo'
  }, {
    icon: <ClipboardCheck className="w-6 h-6" data-id="element-256" />,
    title: 'Autocuidado del Supervisor',
    color: 'text-purple-300',
    bgColor: 'bg-purple-500/20',
    items: 'Los 5 signos de burnout · Sistema de límites operativos · Checklist mensual de bienestar'
  }];
  return <section className="py-20 bg-cyan-950" data-id="element-257">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-258">
        <div className="text-center mb-12" data-id="element-259">
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[20px]" data-id="element-260">
            🎯 ¿QUÉ AGREGA EL "SISTEMA MAESTRO DE SUPERVISIÓN Y COORDINACIÓN
            ABA"?
          </h2>
          <p className="text-cyan-100 text-[14px]" data-id="element-261">
            La diferencia entre ser el terapeuta que trabaja solo y el Director
            Clínico que multiplica resultados.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="mb-16 overflow-x-auto pb-4" data-id="element-262">
          <div className="min-w-[800px]" data-id="element-263">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-264">
              <div className="font-bold text-cyan-300 uppercase text-sm tracking-wider" data-id="element-265">
                Situación real
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-266">
                <X className="w-4 h-4" data-id="element-267" /> Sin Sistema Maestro
              </div>
              <div className="font-bold text-emerald-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-268">
                <Check className="w-4 h-4" data-id="element-269" /> Con Sistema Maestro
              </div>
            </div>

            <div className="space-y-3" data-id="element-270">
              {comparisons.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-cyan-900/60 rounded-xl p-4 items-center border border-cyan-800" data-id="element-271">
                  <div className="font-medium text-white" data-id="element-272">{row.situation}</div>
                  <div className="text-cyan-200 text-sm" data-id="element-273">{row.without}</div>
                  <div className="text-emerald-200 font-medium text-sm bg-emerald-500/15 p-2 rounded-lg border border-emerald-500/30" data-id="element-274">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-cyan-400 mt-4 md:hidden" data-id="element-275">
            ← Scroll to see full table →
          </p>
        </div>

        {/* Modules Grid */}
        <div className="bg-slate-950 rounded-3xl p-8 md:p-12 text-white shadow-xl border border-cyan-900" data-id="element-276">
          <h3 className="text-2xl font-bold mb-8 flex items-center gap-3 text-white" data-id="element-277">
            <span className="bg-emerald-500 text-white p-1 rounded-full" data-id="element-278">
              <Check className="w-5 h-5" data-id="element-279" />
            </span>
            EL SISTEMA MAESTRO INCLUYE:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-280">
            {modules.map((mod, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-cyan-950/50 rounded-2xl p-6 border border-cyan-900" data-id="element-281">
                <div className="flex items-center gap-3 mb-4" data-id="element-282">
                  <div className={`p-2 rounded-lg ${mod.bgColor} ${mod.color}`} data-id="element-283">
                    {mod.icon}
                  </div>
                  <h4 className="font-bold text-lg text-white" data-id="element-284">{mod.title}</h4>
                </div>
                <p className="text-cyan-100 text-sm leading-relaxed" data-id="element-285">
                  {mod.items}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}